<template>
    <gofix-card title="Awaiting Approval" classContent="mb-0 p-0">
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @row-click="rowClick"
            ref="gofixTable">
            <template slot="gofix_table:total" slot-scope="row">
                {{ row.item.total | formatMoney }}
            </template>
            <template slot="gofix_table:date_issued" slot-scope="row">
                {{ row.item.date_issued | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
            </template>
            <template slot="gofix_table:view" slot-scope="row">
                <gofix-button label="View Detail" outline @click="viewDetail(row.item)" ></gofix-button>
            </template>
        </gofix-table>
    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'approval-awating',
        props: {
            type_selected: {
                type: String,
                default: 'all'
            },
        },
        watch: {
            type_selected: function() {
                this.$refs.gofixTable.$refs.scrollbar.scrollToY(0)
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            ClientContractID: function(val, old) {
                if(val && old || !val)
                    this.$refs.gofixTable.$refs.scrollbar.scrollToY(0)
                    this.$refs.gofixTable.reloadTableKeepFilter();
            }
        },
        data () {
            return {
                tableConfig:{
                    name: 'approval-awating',
                    controls:{
                        create: false,
                        delete: false,
                        reload: false,
                        tableFilter: false,
                        tablePagination: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                    },
                    filter: {},
                    page: 1,
                    limit: -1,
                    isCMS: false,
                    fields: [
                        {
                            key: 'number',
                            label: 'Number',
                            thStyle: "width:120px",
                            width: 200,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'total',
                            label: 'Total',
                            thStyle: "width:130px",
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            width: null,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'date_issued',
                            label: 'Date Issued',
                            isActive: 1,
                            thStyle: "width:110px",
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            width: 150,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'root_path',
                            label: 'Property Name',
                            isActive: 1,
                            thStyle: "width:150px",
                            width: 150,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'status',
                            label: 'Status',
                            isActive: 1,
                            thStyle: "width:110px",
                            width: 150,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'view',
                            label: '',
                            isActive: 1,
                            thStyle: "width:150px",
                            tdClass: 'text-right',
                            width: 150,
                            isFilter: false,
                            sorting: false
                        }
                    ]
                },
                tableItems: []
            };
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.contract_id = this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null;
                tableRequest.type_check = this.type_selected;
                await this.$store.dispatch("AwaitingApprovalController/getAwaitingApproval", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the items", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        });
                        reject();
                    })
            },
            rowClick(item) {
                this.$emit("rowClick", item)
            },
            viewDetail(item) {
                let routeData = null;
                switch (item.type_check) {
                    case 1:
                        routeData = this.$router.resolve(`/approvals/orders/${item.id}`);
                        break;
                    case 2:
                        routeData = this.$router.resolve(`/approvals/fm-payment-vouchers/${item.id}`);
                        break;
                    case 3:
                        routeData = this.$router.resolve(`/approvals/lm-payment-vouchers/${item.id}`);
                        break;
                    case 4:
                        routeData = this.$router.resolve(`/approvals/credit-note/${item.id}`);
                        break; 
                    case 5:
                        routeData = this.$router.resolve(`/approvals/offset-documents/${item.id}`);
                        break; 
                }
                if(routeData){
                    window.open(routeData.href, '_blank');
                }
            }
        }
    }
</script>